module.exports = __webpack_public_path__ + "img/46.9788ed7c.jpg";